import { purchaseAllTypeDict } from '@/dictionary/project/common'

// 采购人及代理机构普通待办统一处理
function purchaserUnifiedProcessing(title, pageType = '', routerNmae) {
  return {
    title: title,
    subtitle: [
      {
        label: '项目名称：',
        prop: 'order_name',
        width: '40%'
      }
    ],
    btn: '查看',
    pageType: pageType,
    routerNmae: routerNmae
  }
}

// 采购人待办 外层kay代表招标询比等采购类型，里层kay代表processType类型
export const purchaserToDoListDict = {
  [purchaseAllTypeDict.BIDDING.value]: {
    '1': {
      title: '投标申请单',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '40%'
        },
        {
          label: '提交时间：',
          prop: 'submit_time',
          width: '30%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'BiddingApplyReview' // 招标资料申请页
    },
    '2': {
      title: '保证金确认',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '40%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      pageType: 'InviteBidDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '81': {
      title: '项目开标',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '开标时间：',
          prop: 'open_time',
          width: '30%'
        }
      ],
      btn: '前往开标大厅',
      pageType: 'PurchaserBidOpenHallHome',
      routerNmae: 'Transit' // 开标大厅
    },
    '82': purchaserUnifiedProcessing(
      '项目评标',
      'InviteBidDetail',
      'HomeTransfer'
    ),
    '83': purchaserUnifiedProcessing(
      '项目竞价',
      'InviteBidDetail',
      'HomeTransfer'
    ),
    '84': purchaserUnifiedProcessing(
      '项目审查结果',
      'InviteBidDetail',
      'HomeTransfer'
    ),
    '91': {
      title: '发布中标候选人',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name'
        }
      ],
      btn: '去处理',
      pageType: 'InviteBidDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '92': {
      title: '发布中标结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'InviteBidDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    }
  },
  [purchaseAllTypeDict.INQUIRY.value]: {
    '1': {
      title: '报价申请单',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '40%'
        },
        {
          label: '提交时间：',
          prop: 'submit_time',
          width: '30%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'InquiryApprovalCheck' // 询比项目详情页
    },
    '2': purchaserUnifiedProcessing(
      '保证金手动确定',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '3': purchaserUnifiedProcessing(
      '文件响应处理',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '81': purchaserUnifiedProcessing(
      '项目开标',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '82': purchaserUnifiedProcessing(
      '项目评标',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '83': purchaserUnifiedProcessing(
      '项目竞价',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '84': purchaserUnifiedProcessing(
      '项目审查结果',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '91': {
      title: '发布成交候选人',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'InquiryDetail',
      routerNmae: 'HomeTransfer' // 询比项目详情页
    },
    '92': {
      title: '发布成交结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'InquiryDetail',
      routerNmae: 'HomeTransfer' // 询比项目详情页
    }
  },
  [purchaseAllTypeDict.COMPETE.value]: {
    '1': {
      title: '报价申请单',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '40%'
        },
        {
          label: '提交时间：',
          prop: 'submit_time',
          width: '30%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'SignUpDetail' // 竞价详情页
    },
    '2': purchaserUnifiedProcessing(
      '保证金手动确定',
      'competitionDetail',
      'HomeTransfer'
    ),
    '3': purchaserUnifiedProcessing(
      '文件响应处理',
      'competitionDetail',
      'HomeTransfer'
    ),
    '81': purchaserUnifiedProcessing(
      '项目开标',
      'competitionDetail',
      'HomeTransfer'
    ),
    '82': purchaserUnifiedProcessing(
      '项目评标',
      'competitionDetail',
      'HomeTransfer'
    ),
    '83': {
      title: '项目竞价',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '竞价开始时间：',
          prop: 'competition_start_time',
          width: '30%'
        }
      ],
      btn: '前往竞价大厅',
      pageType: 'PurchaserCompeteHall',
      routerNmae: 'Transit' // 开标大厅
    },
    '84': purchaserUnifiedProcessing(
      '项目审查结果',
      'competitionDetail',
      'HomeTransfer'
    ),
    '91': purchaserUnifiedProcessing(
      '发布候选公示',
      'competitionDetail',
      'HomeTransfer'
    ),
    '92': {
      title: '发布成交结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'competitionDetail',
      routerNmae: 'HomeTransfer' // 询比项目详情页
    }
  },
  [purchaseAllTypeDict.NEGOTIATION.value]: {
    '1': {
      title: '投标申请单',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '40%'
        },
        {
          label: '提交时间：',
          prop: 'submit_time',
          width: '30%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationDetail',
      routerNmae: 'HomeTransfer'
    },
    '2': purchaserUnifiedProcessing(
      '保证金手动确定',
      'NegotiationDetail',
      'HomeTransfer'
    ),
    '3': {
      title: '供应商资格符合审查',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '81': purchaserUnifiedProcessing(
      '项目开标',
      'NegotiationDetail',
      'HomeTransfer'
    ),
    '82': purchaserUnifiedProcessing(
      '项目评标',
      'NegotiationDetail',
      'HomeTransfer'
    ),
    '83': purchaserUnifiedProcessing(
      '项目竞价',
      'NegotiationDetail',
      'HomeTransfer'
    ),
    '84': {
      title: '审查结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '91': {
      title: '发布候选供应商公示',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '92': {
      title: '发布中标结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    }
  },
  [purchaseAllTypeDict.NEGOTIATION_V2.value]: {
    '1': {
      title: '报价申请单',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '40%'
        },
        {
          label: '提交时间：',
          prop: 'submit_time',
          width: '30%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationV2Detail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '2': purchaserUnifiedProcessing(
      '保证金手动确定',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '3': purchaserUnifiedProcessing(
      '文件响应处理',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '81': purchaserUnifiedProcessing(
      '项目开标',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '82': purchaserUnifiedProcessing(
      '项目评标',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '83': purchaserUnifiedProcessing(
      '项目竞价',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '84': purchaserUnifiedProcessing(
      '项目审查结果',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '91': {
      title: '发布成交候选人',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '谈判时间：',
          prop: 'negotiate_time',
          width: '30%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationV2Detail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '92': {
      title: '发布成交结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationV2Detail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    }
  }
}

// 供应商普通待办统一处理
function supplierUnifiedProcessing(title, pageType = '', routerNmae) {
  return {
    title: title,
    subtitle: [
      {
        label: '项目名称：',
        prop: 'order_name',
        width: '40%'
      }
    ],
    btn: '查看',
    pageType: pageType,
    routerNmae: routerNmae
  }
}
// 供应商待办
export const supplierToDoListDict = {
  [purchaseAllTypeDict.BIDDING.value]: {
    '1': {
      title: '投标申请审核未通过',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '审核时间：',
          prop: 'approval_time',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'SupplierPurchaseSignUp' // 招标详情页
    },
    '3': {
      title: '上传电子投标文件',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '开标时间：',
          prop: 'open_time',
          width: '30%'
        }
      ],
      btn: '去上传',
      routerNmae: 'SupplierPurchaseSignUp' // 招标详情页
    },
    '5': supplierUnifiedProcessing('保证金退款', '', 'SupplierPurchaseSignUp'),
    '21': {
      title: '支付费用',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '费用：',
          prop: 'book_fee',
          unit: '元',
          width: '30%'
        },
        {
          label: '响应截止时间：',
          prop: 'sign_up_end_time',
          width: '30%'
        }
      ],
      btn: '前往支付',
      routerNmae: 'SupplierPurchaseSignUp' // 招标详情页
    },
    '22': supplierUnifiedProcessing('平台使用费', '', 'SupplierPurchaseSignUp'),
    '23': {
      title: '服务费',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '服务费：',
          prop: 'service_fee',
          unit: '元',
          width: '30%'
        }
      ],
      btn: '前往支付',
      routerNmae: 'SupplierPurchaseSignUp' // 招标详情页
    },
    '24': {
      title: '缴纳保证金',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '保证金：',
          prop: 'guarantee_fee',
          unit: '元',
          width: '30%'
        }
      ],
      btn: '前往缴纳',
      routerNmae: 'SupplierPurchaseSignUp' // 招标详情页
    },
    '31': {
      title: '上传电子投标文件（澄清）',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '开标时间：',
          prop: 'open_time',
          width: '30%'
        }
      ],
      btn: '去上传',
      routerNmae: 'SupplierPurchaseSignUp' // 招标详情页
    },
    '41': supplierUnifiedProcessing(
      '品目首轮报价',
      '',
      'SupplierPurchaseSignUp'
    ),
    '42': supplierUnifiedProcessing(
      '品目多轮报价',
      '',
      'SupplierPurchaseSignUp'
    ),
    '43': supplierUnifiedProcessing('报价单签章', '', 'SupplierPurchaseSignUp'),
    '71': {
      title: '查看答疑澄清',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '发布时间：',
          prop: 'supplement_time',
          width: '30%'
        }
      ],
      btn: '查看',
      routerNmae: 'SupplierPurchaseSignUp' // 招标详情页
    },
    '81': {
      title: '项目开标',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '开标时间：',
          prop: 'open_time',
          width: '30%'
        }
      ],
      btn: '前往开标大厅',
      pageType: 'SupplierBidOpenHallHome',
      routerNmae: 'Transit' // 供应商开标大厅
    },
    '82': {
      title: '项目评标',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '评标时间：',
          prop: 'review_start_time',
          width: '30%'
        }
      ],
      btn: '前往评标大厅',
      pageType: 'SupplierReviewSession',
      routerNmae: 'Transit' // 供应商评标大厅
    },
    '83': supplierUnifiedProcessing('项目竞价', '', 'SupplierPurchaseSignUp'),
    '91': supplierUnifiedProcessing(
      '发布候选公示',
      '',
      'SupplierPurchaseSignUp'
    ),
    '92': supplierUnifiedProcessing(
      '发布中标结果',
      '',
      'SupplierPurchaseSignUp'
    )
  },
  [purchaseAllTypeDict.INQUIRY.value]: {
    '1': {
      title: '报价申请审核未通过',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '审核时间：',
          prop: 'approval_time',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'SupplierInquiryTrade' // 询比详情页
    },
    '3': supplierUnifiedProcessing(
      '上传电子投标文件',
      '',
      'SupplierInquiryTrade'
    ),
    '5': supplierUnifiedProcessing('保证金退款', '', 'SupplierInquiryTrade'),
    '22': {
      title: '支付平台使用费',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '平台使用费：',
          prop: 'sign_up_fee',
          unit: '元',
          width: '30%'
        },
        {
          label: '报价截止时间：',
          prop: 'offer_end_time',
          width: '30%'
        }
      ],
      btn: '前往支付',
      routerNmae: 'SupplierInquiryTrade' // 询比详情页
    },
    '23': {
      title: '支付平台服务费',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '平台服务费：',
          prop: 'service_fee',
          width: '30%'
        }
      ],
      btn: '前往支付',
      routerNmae: 'SupplierInquiryTrade' // 询比详情页
    },
    '24': {
      title: '缴纳保证金',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '保证金：',
          prop: 'guarantee_fee',
          unit: '元',
          width: '30%'
        },
        {
          label: '报价截止时间：',
          prop: 'offer_end_time',
          width: '30%'
        }
      ],
      btn: '前往缴纳',
      routerNmae: 'SupplierInquiryTrade' // 询比详情页
    },
    '31': supplierUnifiedProcessing(
      '上传电子投标文件（澄清）',
      '',
      'SupplierInquiryTrade'
    ),
    '41': {
      title: '提交报价单',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '报价截止时间：',
          prop: 'offer_end_time',
          width: '30%'
        }
      ],
      btn: '前往报价',
      routerNmae: 'SupplierInquiryTrade' // 询比详情页
    },
    '42': {
      title: '多轮报价',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '报价截止时间：',
          prop: 'offer_end_time',
          width: '30%'
        },
        {
          label: '当前报价轮次：',
          prop: 'round_num',
          width: '30%'
        }
      ],
      btn: '前往报价',
      routerNmae: 'SupplierInquiryTrade' // 询比详情页
    },
    '43': supplierUnifiedProcessing('报价单签章', '', 'SupplierInquiryTrade'),
    '71': {
      title: '查看答疑澄清',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '发布时间：',
          prop: 'supplement_time',
          width: '30%'
        }
      ],
      btn: '查看',
      routerNmae: 'SupplierInquiryTrade' // 询比详情页
    },
    '81': supplierUnifiedProcessing('项目开标', '', 'SupplierInquiryTrade'),
    '82': supplierUnifiedProcessing('项目评标', '', 'SupplierInquiryTrade'),
    '83': supplierUnifiedProcessing('项目竞价', '', 'SupplierInquiryTrade'),
    '91': supplierUnifiedProcessing('发布候选公示', '', 'SupplierInquiryTrade'),
    '92': supplierUnifiedProcessing('发布中标结果', '', 'SupplierInquiryTrade')
  },
  [purchaseAllTypeDict.COMPETE.value]: {
    '1': {
      title: '报价申请审核未通过',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '审核时间：',
          prop: 'approval_time',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'SupplierCompeteSignUp' // 招标详情页
    },
    '3': supplierUnifiedProcessing(
      '上传电子投标文件',
      '',
      'SupplierCompeteSignUp'
    ),
    '5': supplierUnifiedProcessing('保证金退款', '', 'SupplierCompeteSignUp'),
    '22': {
      title: '支付平台使用费',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '平台使用费：',
          prop: 'sign_up_fee',
          unit: '元',
          width: '30%'
        },
        {
          label: '竞价开始时间：',
          prop: 'competition_start_time',
          width: '30%'
        }
      ],
      btn: '前往支付',
      routerNmae: 'SupplierCompeteSignUp' // 招标详情页
    },
    '23': {
      title: '支付平台服务费',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '平台服务费：',
          prop: 'service_fee',
          width: '30%'
        }
      ],
      btn: '前往支付',
      routerNmae: 'SupplierCompeteSignUp' // 报价单提交页
    },
    '24': {
      title: '缴纳保证金',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '保证金：',
          prop: 'guarantee_fee',
          unit: '元',
          width: '30%'
        },
        {
          label: '竞价开始时间：',
          prop: 'competition_start_time',
          width: '30%'
        }
      ],
      btn: '前往缴纳',
      routerNmae: 'SupplierCompeteSignUp' // 招标详情页
    },
    '41': supplierUnifiedProcessing('提交报价单', '', 'SupplierCompeteSignUp'),
    '42': supplierUnifiedProcessing('多伦报价', '', 'SupplierCompeteSignUp'),
    '43': supplierUnifiedProcessing('报价单签章', '', 'SupplierCompeteSignUp'),
    '71': {
      title: '查看答疑澄清',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '发布时间：',
          prop: 'supplement_time',
          width: '30%'
        }
      ],
      btn: '查看',
      routerNmae: 'SupplierCompeteSignUp' // 报价单提交页
    },
    '81': supplierUnifiedProcessing('项目开标', '', 'SupplierCompeteSignUp'),
    '82': supplierUnifiedProcessing('项目评标', '', 'SupplierCompeteSignUp'),
    '83': {
      title: '项目竞价',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '竞价开始时间：',
          prop: 'competition_start_time',
          width: '30%'
        }
      ],
      btn: '前往竞价大厅',
      pageType: 'SupplierCompeteHall',
      routerNmae: 'Transit' // 前往竞价大厅
    },
    '91': supplierUnifiedProcessing(
      '发布候选公示',
      '',
      'SupplierCompeteSignUp'
    ),
    '92': supplierUnifiedProcessing('发布中标结果', '', 'SupplierCompeteSignUp')
  },
  [purchaseAllTypeDict.NEGOTIATION.value]: {
    '1': {
      title: '投标申请审核未通过',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '审核时间：',
          prop: 'approval_time',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'SupplierNegotiationTrade' // 招标详情页
    },
    '3': supplierUnifiedProcessing(
      '上传电子投标文件',
      '',
      'SupplierNegotiationTrade'
    ),
    '5': supplierUnifiedProcessing(
      '保证金退款',
      '',
      'SupplierNegotiationTrade'
    ),
    '21': {
      title: '支付谈判标书费',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '标书费：',
          prop: 'book_fee',
          unit: '元',
          width: '30%'
        },
        {
          label: '响应截止时间：',
          prop: 'sign_up_end_time',
          width: '30%'
        }
      ],
      btn: '前往支付',
      routerNmae: 'SupplierNegotiationTrade' // 谈判详情页
    },
    '23': {
      title: '支付平台服务费',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '平台服务费：',
          prop: 'service_fee',
          unit: '元',
          width: '30%'
        }
      ],
      btn: '前往缴纳',
      routerNmae: 'SupplierNegotiationTrade' // 招标详情页
    },
    '24': {
      title: '缴纳保证金',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '保证金：',
          prop: 'guarantee_fee',
          unit: '元',
          width: '30%'
        },
        {
          label: '谈判响应截止时间：',
          prop: 'response_end_time',
          width: '30%'
        }
      ],
      btn: '前往缴纳',
      routerNmae: 'SupplierNegotiationTrade' // 招标详情页
    },
    '31': supplierUnifiedProcessing(
      '上传电子投标文件（澄清）',
      '',
      'SupplierNegotiationTrade'
    ),
    '41': supplierUnifiedProcessing(
      '提交报价单',
      '',
      'SupplierNegotiationTrade'
    ),
    '42': supplierUnifiedProcessing('多伦报价', '', 'SupplierNegotiationTrade'),
    '43': supplierUnifiedProcessing(
      '报价单签章',
      '',
      'SupplierNegotiationTrade'
    ),
    '71': supplierUnifiedProcessing(
      '查看答疑澄清',
      '',
      'SupplierNegotiationTrade'
    ),
    '81': supplierUnifiedProcessing('项目开标', '', 'SupplierNegotiationTrade'),
    '82': supplierUnifiedProcessing('项目评标', '', 'SupplierNegotiationTrade'),
    '83': supplierUnifiedProcessing('项目竞价', '', 'SupplierNegotiationTrade'),
    '91': supplierUnifiedProcessing(
      '发布候选公示',
      '',
      'SupplierNegotiationTrade'
    ),
    '92': supplierUnifiedProcessing(
      '发布中标结果',
      '',
      'SupplierNegotiationTrade'
    )
  },
  [purchaseAllTypeDict.NEGOTIATION_V2.value]: {
    '1': {
      title: '报价申请审核未通过',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '审核时间：',
          prop: 'approval_time',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'SupplierNegotiationV2Trade' // 招标详情页
    },
    '3': supplierUnifiedProcessing(
      '上传电子投标文件',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '5': supplierUnifiedProcessing(
      '保证金退款',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '21': supplierUnifiedProcessing(
      '支付谈判标书费',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '22': {
      title: '支付平台使用费',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '平台使用费：',
          prop: 'sign_up_fee',
          unit: '元',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'SupplierNegotiationV2Trade' // 招标详情页
    },
    '23': supplierUnifiedProcessing(
      '支付平台服务费',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '24': supplierUnifiedProcessing(
      '缴纳保证金',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '31': supplierUnifiedProcessing(
      '上传电子投标文件（澄清）',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '41': {
      title: '提交报价单',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '谈判时间：',
          prop: 'response_end_time',
          width: '30%'
        }
      ],
      btn: '前往报价',
      routerNmae: 'SupplierNegotiationV2Trade' // 报价单提交页
    },
    '42': supplierUnifiedProcessing(
      '多伦报价',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '43': supplierUnifiedProcessing(
      '报价单签章',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '71': {
      title: '查看答疑澄清',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '发布时间：',
          prop: 'supplement_time',
          width: '30%'
        }
      ],
      btn: '查看',
      routerNmae: 'SupplierNegotiationV2Trade' // 报价单提交页
    },
    '81': supplierUnifiedProcessing(
      '项目开标',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '82': supplierUnifiedProcessing(
      '项目评标',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '83': supplierUnifiedProcessing(
      '项目竞价',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '91': supplierUnifiedProcessing(
      '发布候选公示',
      '',
      'SupplierNegotiationV2Trade'
    ),
    '92': supplierUnifiedProcessing(
      '发布中标结果',
      '',
      'SupplierNegotiationV2Trade'
    )
  }
}

// 代理机构待办
export const agencyToDoListDict = {
  [purchaseAllTypeDict.BIDDING.value]: {
    '1': {
      title: '投标申请单',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '40%'
        },
        {
          label: '提交时间：',
          prop: 'submit_time',
          width: '30%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'AgencyInviteBidApplyForm' // 待办招标资料申请页
    },
    '2': {
      title: '保证金确认',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '50%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '50%'
        }
      ],
      btn: '去处理',
      pageType: 'InviteBidDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '81': {
      title: '项目开标',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '50%'
        },
        {
          label: '开标时间：',
          prop: 'open_time',
          width: '50%'
        }
      ],
      btn: '前往开标大厅',
      pageType: 'PurchaserBidOpenHallHome',
      routerNmae: 'Transit' // 开标大厅
    },
    '82': purchaserUnifiedProcessing(
      '项目评标',
      'InviteBidDetail',
      'HomeTransfer'
    ),
    '83': purchaserUnifiedProcessing(
      '项目竞价',
      'InviteBidDetail',
      'HomeTransfer'
    ),
    '84': purchaserUnifiedProcessing(
      '项目审查结果',
      'InviteBidDetail',
      'HomeTransfer'
    ),
    '91': {
      title: '发布中标候选人',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name'
        }
      ],
      btn: '去处理',
      pageType: 'InviteBidDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '92': {
      title: '发布中标结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'InviteBidDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    }
  },
  [purchaseAllTypeDict.INQUIRY.value]: {
    '1': {
      title: '报价申请单',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '40%'
        },
        {
          label: '提交时间：',
          prop: 'submit_time',
          width: '30%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'AgencyInquiryApprovalCheck' // 待办询比项目详情页
    },
    '2': purchaserUnifiedProcessing(
      '保证金手动确定',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '3': purchaserUnifiedProcessing(
      '文件响应处理',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '81': purchaserUnifiedProcessing(
      '项目开标',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '82': purchaserUnifiedProcessing(
      '项目评标',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '83': purchaserUnifiedProcessing(
      '项目竞价',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '84': purchaserUnifiedProcessing(
      '项目审查结果',
      'InquiryDetail',
      'HomeTransfer'
    ),
    '91': {
      title: '发布成交候选人',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'InquiryDetail',
      routerNmae: 'HomeTransfer' // 询比项目详情页
    },
    '92': {
      title: '发布成交结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'InquiryDetail',
      routerNmae: 'HomeTransfer' // 询比项目详情页
    }
  },
  [purchaseAllTypeDict.COMPETE.value]: {
    '1': {
      title: '报价申请单',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '40%'
        },
        {
          label: '提交时间：',
          prop: 'submit_time',
          width: '30%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'AgencySignUpDetail' // 竞价详情页
    },
    '2': purchaserUnifiedProcessing(
      '保证金手动确定',
      'competitionDetail',
      'HomeTransfer'
    ),
    '3': purchaserUnifiedProcessing(
      '文件响应处理',
      'competitionDetail',
      'HomeTransfer'
    ),
    '81': purchaserUnifiedProcessing(
      '项目开标',
      'competitionDetail',
      'HomeTransfer'
    ),
    '82': purchaserUnifiedProcessing(
      '项目评标',
      'competitionDetail',
      'HomeTransfer'
    ),
    '83': {
      title: '项目竞价',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '50%'
        },
        {
          label: '竞价开始时间：',
          prop: 'competition_start_time',
          width: '50%'
        }
      ],
      btn: '前往竞价大厅',
      pageType: 'PurchaserCompeteHall',
      routerNmae: 'Transit' // 竞价大厅
    },
    '84': purchaserUnifiedProcessing(
      '项目审查结果',
      'competitionDetail',
      'HomeTransfer'
    ),
    '91': purchaserUnifiedProcessing(
      '发布候选公示',
      'competitionDetail',
      'HomeTransfer'
    ),
    '92': {
      title: '发布成交结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'competitionDetail',
      routerNmae: 'HomeTransfer' // 询比项目详情页
    }
  },
  [purchaseAllTypeDict.NEGOTIATION.value]: {
    '1': {
      title: '投标申请单',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '40%'
        },
        {
          label: '提交时间：',
          prop: 'submit_time',
          width: '30%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationDetail',
      routerNmae: 'HomeTransfer'
    },
    '2': purchaserUnifiedProcessing(
      '保证金手动确定',
      'NegotiationDetail',
      'HomeTransfer'
    ),
    '3': {
      title: '供应商资格符合审查',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '81': purchaserUnifiedProcessing(
      '项目开标',
      'NegotiationDetail',
      'HomeTransfer'
    ),
    '82': purchaserUnifiedProcessing(
      '项目评标',
      'NegotiationDetail',
      'HomeTransfer'
    ),
    '83': purchaserUnifiedProcessing(
      '项目竞价',
      'NegotiationDetail',
      'HomeTransfer'
    ),
    '84': {
      title: '审查结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '91': {
      title: '发布候选供应商公示',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '92': {
      title: '发布中标结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationDetail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    }
  },
  [purchaseAllTypeDict.NEGOTIATION_V2.value]: {
    '1': {
      title: '报价申请单',
      subtitle: [
        {
          label: '供应商名称：',
          prop: 'supplier_name',
          width: '40%'
        },
        {
          label: '提交时间：',
          prop: 'submit_time',
          width: '30%'
        },
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationV2Detail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '2': purchaserUnifiedProcessing(
      '保证金手动确定',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '3': purchaserUnifiedProcessing(
      '文件响应处理',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '81': purchaserUnifiedProcessing(
      '项目开标',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '82': purchaserUnifiedProcessing(
      '项目评标',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '83': purchaserUnifiedProcessing(
      '项目竞价',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '84': purchaserUnifiedProcessing(
      '项目审查结果',
      'NegotiationV2Detail',
      'HomeTransfer'
    ),
    '91': {
      title: '发布成交候选人',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '40%'
        },
        {
          label: '谈判时间：',
          prop: 'negotiate_time',
          width: '30%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationV2Detail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    },
    '92': {
      title: '发布成交结果',
      subtitle: [
        {
          label: '项目名称：',
          prop: 'order_name',
          width: '90%'
        }
      ],
      btn: '去处理',
      pageType: 'NegotiationV2Detail',
      routerNmae: 'HomeTransfer' // 招标项目详情页
    }
  },
  '0': {
    '101': {
      title: '代理委托单',
      subtitle: [
        {
          label: '采购单位：',
          prop: 'purchase_company_name',
          width: '40%'
        },
        {
          label: '项目名称：',
          prop: 'project_name',
          width: '30%'
        }
      ],
      btn: '去处理',
      routerNmae: 'AgencyEntrustDetail' // 竞价详情页
    }
  }
}
